module.exports = __webpack_public_path__ + "static/media/wor_clo_to_wat_edg_pro.5362d954.png";